import React from 'react';
import PropTypes from 'prop-types';
import { Toggle } from '@storable/canaveral-components';
import OGTagInput from './OGTagInput';
import style from './OGTags.scss';

const baseOGProperties = [
  { property: 'og:title', placeholder: 'Title of Page', syncableVar: 'title' },
  { property: 'og:description', placeholder: 'Insert content excerpt', syncableVar: 'description' },
  { property: 'og:url', placeholder: 'Insert absolute URL of page' },
  { property: 'og:image', placeholder: 'Insert URL of image' },
  { property: 'og:type', placeholder: 'Website' },
];

// TODO when we allow the user to add extra rows, make sure they aren't using these base properties

export const syncableOGProperties = baseOGProperties.filter(base => base.syncableVar);

const propTypes = {
  metaTags: PropTypes.arrayOf(PropTypes.shape({
    property: PropTypes.string.isRequired,
    content: PropTypes.string,
  })),
  updateMetaTags: PropTypes.func.isRequired,
  syncOGTags: PropTypes.bool,
  description: PropTypes.string,
  title: PropTypes.string,
  toggleSyncOGTags: PropTypes.func.isRequired,
};

const defaultProps = {};

class OGTags extends React.Component {
  updateOGTag = (newTag) => {
    const { metaTags, updateMetaTags } = this.props;
    const updatedTags = [...metaTags];

    const currentTagIdx = updatedTags.findIndex(tag => tag.property === newTag.property);

    if (!newTag.content.length) {
      updatedTags.splice(currentTagIdx, 1);
    } else if (currentTagIdx > -1) {
      updatedTags[currentTagIdx] = newTag;
    } else {
      updatedTags.push(newTag);
    }

    updateMetaTags(updatedTags);
  }

  render() {
    const {
      metaTags,
      syncOGTags,
      toggleSyncOGTags,
    } = this.props;

    const ogTagInputs = baseOGProperties.map((base) => {
      const currentTag = metaTags.find(tag => tag.property === base.property);

      const ogTagProps = {
        key: base.property,
        property: base.property,
        onChange: this.updateOGTag,
        readOnlyProperty: true,
        content: currentTag ? currentTag.content : '',
        placeholder: base.placeholder,
        readOnlyContent: base.syncableVar && syncOGTags,
      };

      return (
        <OGTagInput {...ogTagProps} />
      );
    });

    return (
      <div>
        <div className={style.sectionHeader}>
          Add Open Graph Tags
        </div>
        <div className={style.sectionInfo}>
          Open graph tags allow you to control how page information appears on social
          media. While they don't impact your SEO directly, they can affect your conversion and click
          through rates, so use carefully.
        </div>
        <div>
          <span className={style.toggle} onClick={toggleSyncOGTags}>
            <Toggle checked={syncOGTags} readOnly />
          </span>
          <span className={style.ogSyncInfo}>
            <div className={style.sectionHeader}>
              Use title and description from page settings
            </div>
            <div className={style.sectionInfo}>
              When enabled, this automatically updates these OG tag fields when they are modified.
            </div>
          </span>
        </div>
        <div>
          {ogTagInputs}
        </div>
      </div>
    );
  }
}

OGTags.propTypes = propTypes;
OGTags.defaultProps = defaultProps;

export default OGTags;
